import SvgIcon from '@ixigo/icons/SvgIcon';
import cn from '@repo/shared/utils/cn';

export const SearchError = (props: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<SvgIcon
			className={cn(props.className)}
			data-testid="SearchErrorIcon"
			width="72"
			height="69"
			viewBox="0 0 72 69"
			fill="none"
			{...props}
		>
			<path
				d="M7.58967 58.2008L2.50244 26.8289L8.07244 20.6953L54.8487 21.5567L60.8163 49.9182C62.1377 56.1985 57.8447 62.2782 51.4842 63.1341L19.9609 67.376C14.0326 68.1737 8.54715 64.1054 7.58967 58.2008Z"
				fill="#BEBFBF"
			/>
			<path
				d="M8.88895 50.3337L3.63183 26.1848L9.75518 19.8164L59.0064 20.9239C60.0376 25.764 61.5803 36.724 62.4713 41.3508C63.3938 46.1414 65.1253 48.2583 69.6532 51.605C70.4677 52.207 70.1425 53.5085 69.1367 53.6276C53.6622 55.4596 24.455 58.793 18.7887 59.4396C12.7499 60.1287 9.67268 53.6561 8.88895 50.3337Z"
				fill="url(#paint0_linear_6716_71871)"
			/>
			<path
				d="M2.47782 26.8575L3.64076 26.2013L3.4781 11.0273C1.37501 12.3659 0.291802 14.8446 0.738116 17.2972L2.47782 26.8575Z"
				fill="#9E302E"
			/>
			<ellipse
				cx="3.45661"
				cy="3.67566"
				rx="3.45661"
				ry="3.67566"
				transform="matrix(0.995498 -0.0947862 0.0958476 0.995396 15.4756 28.8125)"
				fill="white"
			/>
			<ellipse
				cx="3.45662"
				cy="3.67566"
				rx="3.45662"
				ry="3.67566"
				transform="matrix(0.995498 -0.0947862 0.0958476 0.995396 18.1089 39.1016)"
				fill="white"
			/>
			<path
				d="M28.2847 51.9449C28.4793 53.9655 27.3753 55.2672 25.4749 55.4481C23.5744 55.6291 21.5972 54.6208 21.4026 52.6001C21.208 50.5795 22.5909 48.7947 24.4913 48.6138C26.3918 48.4328 28.0901 49.9242 28.2847 51.9449Z"
				fill="white"
			/>
			<ellipse
				cx="3.45662"
				cy="3.67566"
				rx="3.45662"
				ry="3.67566"
				transform="matrix(0.995498 -0.0947862 0.0958476 0.995396 30.563 27.3789)"
				fill="white"
			/>
			<ellipse
				cx="3.45661"
				cy="3.67566"
				rx="3.45661"
				ry="3.67566"
				transform="matrix(0.995498 -0.0947862 0.0958476 0.995396 33.1963 37.6641)"
				fill="white"
			/>
			<path
				d="M43.3718 50.5099C43.5664 52.5306 42.6789 53.5771 40.7785 53.758C38.878 53.939 36.8768 53.1866 36.6823 51.166C36.4877 49.1453 37.6781 47.3597 39.5785 47.1788C41.4789 46.9978 43.1773 48.4892 43.3718 50.5099Z"
				fill="white"
			/>
			<ellipse
				cx="3.45662"
				cy="3.67566"
				rx="3.45662"
				ry="3.67566"
				transform="matrix(0.995498 -0.0947862 0.0958476 0.995396 44.3271 26.0664)"
				fill="white"
			/>
			<ellipse
				cx="3.45661"
				cy="3.67566"
				rx="3.45661"
				ry="3.67566"
				transform="matrix(0.995498 -0.0947862 0.0958475 0.995396 46.9604 36.3555)"
				fill="white"
			/>
			<path
				d="M57.1358 49.1977C57.3304 51.2184 56.643 52.0942 54.7425 52.2752C52.8421 52.4561 50.8409 51.7654 50.6463 49.7448C50.4518 47.7241 51.442 46.0476 53.3425 45.8666C55.2429 45.6857 56.9413 47.1771 57.1358 49.1977Z"
				fill="white"
			/>
			<path
				d="M43.8638 7.42285C51.0712 7.04334 57.4404 12.0751 58.7388 19.1748L59.0767 21.0234L3.63721 26.2051L3.54834 25.707C2.02636 17.2077 8.29884 9.29736 16.9214 8.84277L43.8638 7.42285ZM15.4937 13.0381C14.0494 13.2708 13.0783 14.688 13.3247 16.2021C13.5716 17.716 14.9422 18.7547 16.3862 18.5225C17.8304 18.2896 18.8017 16.8735 18.5552 15.3594C18.3084 13.8455 16.9377 12.806 15.4937 13.0381ZM29.687 12.2617C28.2428 12.4944 27.2717 13.9107 27.5181 15.4248C27.7648 16.939 29.1362 17.9786 30.5806 17.7461C32.0247 17.5133 32.9958 16.0971 32.7495 14.583C32.5029 13.0687 31.1315 12.0291 29.687 12.2617ZM46.9419 13.7402C46.6953 12.2259 45.3248 11.1864 43.8804 11.4189C42.4359 11.6516 41.4648 13.0687 41.7114 14.583C41.9582 16.097 43.3288 17.1356 44.7729 16.9033C46.2174 16.6707 47.1885 15.2546 46.9419 13.7402Z"
				fill="#E35D5B"
			/>
			<path
				d="M21.0191 9.31213C21.0191 6.38183 18.8408 4.13559 16.3076 4.13559C13.7744 4.13561 11.5962 6.38185 11.5962 9.31213H9.82959C9.82959 5.55457 12.661 2.37893 16.3076 2.37891C19.9542 2.37891 22.7856 5.55455 22.7856 9.31213C22.7856 11.1875 22.0328 13.3703 20.5511 14.8931C19.0219 16.4646 16.7448 17.2947 13.9088 16.4075C13.4434 16.2619 13.2072 15.9371 13.3313 15.3057C13.3313 15.3057 13.3917 14.5077 13.8098 14.6385C15.9826 15.3183 18.199 14.7845 19.2818 13.6717C20.4121 12.5101 21.019 10.7806 21.0191 9.31213Z"
				fill="#BEBFBF"
			/>
			<path
				d="M35.1148 8.6051C35.1148 5.6748 32.9365 3.42855 30.4033 3.42855C27.8701 3.42858 25.6919 5.67482 25.6919 8.6051H23.9253C23.9253 4.84753 26.7567 1.6719 30.4033 1.67188C34.0499 1.67188 36.8814 4.84752 36.8814 8.6051C36.8813 10.4805 36.1285 12.6633 34.6468 14.1861C33.1176 15.7576 30.8405 16.5877 28.0045 15.7004C27.5391 15.5549 27.3029 15.23 27.427 14.5987C27.427 14.5987 27.4874 13.8007 27.9055 13.9315C30.0783 14.6112 32.2947 14.0775 33.3775 12.9646C34.5078 11.803 35.1147 10.0736 35.1148 8.6051Z"
				fill="#BEBFBF"
			/>
			<path
				d="M49.3736 7.74182C49.3736 4.81152 47.1953 2.56527 44.6621 2.56527C42.1289 2.5653 39.9507 4.81154 39.9507 7.74182H38.1841C38.1841 3.98425 41.0155 0.808621 44.6621 0.808594C48.3087 0.808594 51.1401 3.98424 51.1401 7.74182C51.1401 9.61721 50.3873 11.8 48.9056 13.3228C47.3764 14.8943 45.0993 15.7244 42.2633 14.8372C41.7979 14.6916 41.5617 14.3668 41.6858 13.7354C41.6858 13.7354 41.7462 12.9374 42.1643 13.0682C44.3371 13.748 46.5535 13.2142 47.6363 12.1014C48.7666 10.9397 49.3735 9.2103 49.3736 7.74182Z"
				fill="#BEBFBF"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_6716_71871"
					x1="32.977"
					y1="23.7364"
					x2="73.3114"
					y2="55.2986"
					gradientUnits="userSpaceOnUse"
				>
					<stop stop-color="#E3E4E6" />
					<stop offset="1" stop-color="#CACDD1" />
				</linearGradient>
			</defs>
		</SvgIcon>
	);
};
